export const scoreTitle = 'Správné odpovědi:'
export const nextButton = 'Další otázka'
export const lastButton = 'Vyhodnocení'
export const correctAnswer = {
  isCorrect: true,
  image: require('@/assets/thumb-up.svg'),
  title: 'Správná odpověď',
}
export const wrongAnswer = {
  isCorrect: false,
  image: require('@/assets/thumb-down.svg'),
  title: 'Špatná odpověď',
}
export const questions = [
  {
    question: 'Jedním z&nbsp;kroků čištění odpadní vody je provzdušňování',
    answer: true,
    description:
      'Ano, vodu provzdušňujeme v&nbsp;části aktivační nádrže, abychom vytvořili dobré životní podmínky pro mikroorganismy, které čistí vodu.',
    image: require('@/assets/img01.svg'),
  },
  {
    question: 'Pouze 1&nbsp;% světové vody se dá využít k&nbsp;pití',
    answer: true,
    description:
      'Je to tak. I&nbsp;když vody je na zeměkouli ohromné množství, k&nbsp;pití se dá využít jen jedno procento sladké povrchové vody. A&nbsp;to musí obvykle projít úpravnou vody, aby byla skutečně pitná.',
    image: require('@/assets/img02.svg'),
  },
  {
    question: 'Vody neustále ubývá',
    answer: false,
    description:
      'Vody je po miliony let na Zemi stejně (dokonce velmi pomalu přibývá), jen se přesouvá a&nbsp;mění své skupenství.',
    image: require('@/assets/img03.svg'),
  },
  {
    question: 'Zhruba 5&nbsp;% Čechů má vlastní studnu',
    answer: true,
    description: 'Je to tak. Většina Čechů využívá vodu z&nbsp;veřejného vodovodu.',
    image: require('@/assets/img04.svg'),
  },
  {
    question: 'Voda se v&nbsp;úpravně vody dezinfikuje přídáním kapky dusíku',
    answer: false,
    description: 'Dusík se do vody nepřidává. Dezinfikuje se ozonem, UV zářením nebo chlorem.',
    image: require('@/assets/img05.svg'),
  },
  {
    question: 'Tuk je těžší než voda, a&nbsp;tak se v&nbsp;čističce vody usazuje u&nbsp;dna',
    answer: false,
    description:
      'Tuk je lehčí než voda, plave tedy na jejím povrchu a&nbsp;při čištění ho zachytávají horní lapáky.',
    image: require('@/assets/img06.svg'),
  },
  {
    question: 'Jen 0.01&nbsp;% veškeré vody je tvořeno povrchovými zdroji - jezera, mokřady, řeky.',
    answer: true,
    description:
      'Může se to zdát až neuvěřitelné, ale je to tak. Většina vody na naší planetě se nachází v&nbsp;oceánech, podzemních zdrojích a&nbsp;ledovcích.',
    image: require('@/assets/img07.svg'),
  },
  {
    question: 'Kal, který vznikne během čištění vody, se využívá k&nbsp;výrobě bioplynu.',
    answer: true,
    description: 'Bioplyn čističky odpadních vod za pomoci agregátů přetvoří na energii.',
    image: require('@/assets/img08.svg'),
  },
  {
    question: 'Průměrná denní spotřeba vody v&nbsp;ČR je 40 litrů na osobu',
    answer: false,
    description:
      'S&nbsp;takovým množství vody si musí vystačit obyvatelé Konga. Češi spotřebují průměrně 100&nbsp;l denně.',
    image: require('@/assets/img09.svg'),
  },
  {
    question: 'Voda se z&nbsp;čističky vrací do přírody jako pitná',
    answer: false,
    description:
      'Voda se sice vrací zpět do přírody, ne však jako pitná. Pro to, aby se dostala zpět do našich kohoutků musí znovu projít úpravou.',
    image: require('@/assets/img10.svg'),
  },
]
export const resultMessages = [
  {
    min: 0,
    max: 0,
    title: 'Samá voda!',
    message:
      'Ajaj, zdá se, že Vaše studna vědomostí je poněkud vyschlá… Projděte si koloběh vody ještě jednou a&nbsp;pozorněji. :)',
  },
  {
    min: 1,
    max: 3,
    title: 'Ajaj!',
    message:
      'No, tady někdo při výběru odpovědí vařil z&nbsp;vody… Doporučujeme si časovou osu projít ještě jednou a&nbsp;pozorněji.',
  },
  {
    min: 4,
    max: 6,
    title: 'Dobrá práce!',
    message:
      'To není vůbec špatné! Vaše znalosti koloběhu vody nejsou sice dokonalé, ale ve vašem případě vidíme sklenici spíše jako poloplnou. :)',
  },
  {
    min: 7,
    max: 9,
    title: 'Výborně!',
    message: 'Skvělá práce! Je vidět, že jste se v&nbsp;našem kvízu cítili jako ryba ve vodě. :)',
  },
  {
    min: 10,
    max: 10,
    title: 'WOW!',
    message:
      'Udělujeme Vám titul krále či královny vod! Gratulujeme vám k&nbsp;bezchybnému výsledku.',
  },
]
